module.exports = __webpack_public_path__ + "img/ico-add.be39c58c.svg";